export function GestationalDiabetesBanner() {
  return (
    <div className="mx-4 mt-4 rounded-card border border-amber-500/30 bg-amber-100/60 px-4 py-3">
      <p className="text-sm font-medium text-ink">Carb targets deferred to your provider</p>
      <p className="mt-0.5 text-xs text-forest-500">
        Since you've flagged gestational diabetes, PregTrack won't set a carbohydrate target
        for you. Please follow the plan your OB/GYN or midwife has given you.
      </p>
    </div>
  );
}

export function ProviderDeferNote({ className = "" }: { className?: string }) {
  return (
    <p className={`text-xs text-forest-500 ${className}`}>
      PregTrack supports your nutrition tracking — it doesn't diagnose. For anything about your
      health or your pregnancy, talk with your OB/GYN or midwife.
    </p>
  );
}
